// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormWrapper_formWrapper__A73MO"};